import { z } from 'zod'

export const newsletterSchema = z.object({
  name: z.string().min(1, 'Nama Lengkap wajib diisi'),
  email: z.string().min(1, 'Email wajib diisi').email({ message: 'format email tidak valid' })
})
